import { createEntityAdapter } from '@reduxjs/toolkit';

import { IFeedItem } from 'api/feed/types';

export const feedItemsAdapter = createEntityAdapter<IFeedItem>({
  selectId: (item) => item.feedItemId as string,
  sortComparer: (a, b) => {
    if (a.pin) {
      return -1;
    }
    if (b.pin) {
      return 1;
    }

    if (a.createdAt! > b.createdAt!) {
      return -1;
    }

    if (a.createdAt! < b.createdAt!) {
      return 1;
    }

    return 0;
  },
});
